import "../sprinkles.css.ts.vanilla.css-mistica.js";
import "./aspect-ratio-support.css.ts.vanilla.css-mistica.js";
var a = "yqswj62", n = "_1y2v1nfbs _1y2v1nfc9 _1y2v1nfeb _1y2v1nfeq", y = {
    aspectRatio: "var(--yqswj60)"
}, e = "_1y2v1nfe5 _1y2v1nfdk _1y2v1nfdl _1y2v1nfaz";
export { a as container, n as containerWithWrapper, y as vars, e as wrapper };
